import { ConfigStore } from './ConfigStore';
import { Container } from 'hypo-container';
import { ProdcatApiSdk } from '../api/ProdcatApiSdk';
import { ServiceBusController } from './ServiceBusController';
import { ProductService } from './ProductService';
import { getDecorators } from 'elc-service';
import { ProductSkuRepository } from '../internal/repositories/ProductSkuRepository';
import { ProductFullViewController } from '../internal/controllers/ProductFullViewController';
import { ZoomViewBaseController } from '../internal/controllers/ZoomViewBaseController';
import { ProductZoomViewController } from '../internal/controllers/ProductZoomViewController';
import { ProductZoomButtonViewController } from '../internal/controllers/ProductZoomButtonViewController';
import { ProductRepository } from '../internal/repositories/ProductRepository';
import { ProductBriefViewController } from '../internal/controllers/ProductBriefViewController';
import { ProductGridViewController } from '../internal/controllers/ProductGridViewController';
import { ProductCrossSellViewController } from '../internal/controllers/ProductCrossSellViewController';
import { CartLimitReachedModalController } from '../internal/controllers/CartLimitReachedModalController';
import { ProductCTAViewController } from '../internal/controllers/ProductCTAViewController';
import { ProductQuickViewController } from '../internal/controllers/ProductQuickViewController';
import { ProductShadesSidebarViewController } from '../internal/controllers/ProductShadesSidebarViewController';
import { ProductFilterService } from '../internal/domain/services/ProductFilterService';
import { UrlFormatter, PriceFormatter, DateFormatter, BusinessUnitIdParser } from 'elc-formatters';
import { Config } from '../internal/domain/entities/Config';
import { ConfigRepository } from '../internal/repositories/ConfigRepository';
import { ProductRatingViewController } from '../internal/controllers/ProductRatingViewController';
import { ProductFiltersViewController } from '../internal/controllers/ProductFiltersViewController';
import { ProductGridSettings } from '../internal/domain/entities/ProductGridSettings';
import { QueryFragments } from '../api/QueryFragments';
import { ProductInstallmentsPriceViewController } from '../internal/controllers/ProductInstallmentsPriceViewController';
import { ProductEngravingViewController } from '../internal/controllers/ProductEngravingViewController';
import { ProductGridService } from '../internal/domain/services/ProductGridService';
import { ProductSortingService } from '../internal/domain/services/ProductSortingService';
import { ProductShadePickerViewController } from '../internal/controllers/ProductShadePickerViewController';
import { ProductShadePickerComponentViewController } from '../internal/controllers/ProductShadePickerComponentViewController';
import { ProductBasicInfoViewController } from '../internal/controllers/ProductBasicInfoViewController';
import { ProductFullOrderableViewController } from '../internal/controllers/ProductFullOrderableViewController';
import { ProductAutoReplenishmentViewController } from '../internal/controllers/ProductAutoReplenishmentViewController';
import { ProductImageSliderViewController } from '../internal/controllers/ProductImagesSliderViewController';
import { ProductSizePickerViewController } from '../internal/controllers/ProductSizePickerViewController';
import { ComparisonItemViewController } from '../internal/controllers/ComparisonItemViewController';
import { ProductComparisonModuleViewController } from '../internal/controllers/ProductComparisonModuleViewController';

export const diContainer = new Container();
export const serviceNames = {
    configStore: 'CONFIG_STORE',
    pubSub: 'PUB_SUB_CLIENT',
    prodcatApiSdk: 'PRODCAT_API_SDK',
    serviceBusController: 'SERVICE_BUS_CONTROLLER',
    productService: 'PRODUCT_SERVICE',
    productSkuRepository: 'PRODUCT_SKU_REPOSITORY',
    productCTAViewController: 'PRODUCT_CTA_VIEW_CONTROLLER',
    productFullViewController: 'PRODUCT_FULL_VIEW_CONTROLLER',
    productFullOrderableViewController: 'PRODUCT_FULL_ORDERABLE_VIEW_CONTROLLER',
    zoomViewBaseController: 'ZOOM_VIEW_BASE_CONTROLLER',
    productZoomButtonViewController: 'PRODUCT_ZOOM_BUTTON_VIEW_CONTROLLER',
    productBriefViewController: 'PRODUCT_BRIEF_VIEW_CONTROLLER',
    productGridViewController: 'PRODUCT_GRID_VIEW_CONTROLLER',
    productRepository: 'PRODUCT_REPOSITORY',
    productCrossSellViewController: 'PRODUCT_CROSS_SELL_VIEW_CONTROLLER',
    productRatingViewController: 'PRODUCT_RATING_VIEW_CONTROLLER',
    cartLimitReachedModalController: 'CART_LIMIT_REACHED_MODAL_CONTROLLER',
    productQuickViewController: 'PRODUCT_QUICK_VIEW_CONTROLLER',
    productFiltersViewController: 'PRODUCT_FILTERS_VIEW_CONTROLLER',
    productShadesSidebarViewController: 'PRODUCT_SHADES_SIDEBAR_VIEW_CONTROLLER',
    productZoomViewController: 'PRODUCT_ZOOM_VIEW_CONTROLLER',
    productFilterService: 'PRODUCT_FILTER_SERVICE',
    businessUnitIdParser: 'BUSINESS_UNIT_ID_PARSER',
    config: 'CONFIG',
    configRepository: 'CONFIG_REPOSITORY',
    productGridSettings: 'MPP_SETTINGS',
    productSelectionRepository: 'PRODUCT_SELECTION_REPOSITORY',
    queryFragments: 'QUERY_FRAGMENTS',
    dateFormatter: 'DATE_FORMATTER',
    priceFormatter: 'PRICE_FORMATTER',
    productInstallmentsPriceViewController: 'PRODUCT_INSTALLMENTS_PRICE_VIEW_CONTROLLER',
    productEngravingViewController: 'PRODUCT_ENGRAVING_VIEW_CONTROLLER',
    productGridService: 'PRODUCT_GRID_SERVICE',
    productSortingService: 'PRODUCT_SORTING_SERVICE',
    productShadePickerViewController: 'PRODUCT_SHADE_PICKER_VIEW_CONTROLLER',
    productShadePickerComponentViewController: 'PRODUCT_SHADE_PICKER_CONMPONENT_VIEW_CONTROLLER',
    productBasicInfoViewController: 'PRODUCT_BASIC_INFO_VIEW_CONTROLLER',
    productAutoReplenishmentViewController: 'PRODUCT_AUTO_REPLENISHMENT_VIEW_CONTROLLER',
    productImagesSliderViewController: 'PRODUCT_IMAGES_SLIDER_VIEW_CONTROLLER',
    productSizePickerViewController: 'PRODUCT_SIZE_PICKER_VIEW_CONTROLLER',
    comparisonItemViewController: 'COMPARISON_ITEM_VIEW_CONTROLLER',
    productComparisonModuleViewController: 'PRODUCT_COMPARISON_MODULE_VIEW_CONTROLLER',
    urlFormatter: 'URL_FORMATTER'
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const setConfig = (configJSON: any) => {
    diContainer.config = configJSON;
};

diContainer
    .register(serviceNames.configStore, (c) => new ConfigStore(c.config))
    .register(
        serviceNames.productFullViewController,
        (c) => new ProductFullViewController(c.get(serviceNames.queryFragments))
    )
    .register(
        serviceNames.productFullOrderableViewController,
        (c) => new ProductFullOrderableViewController(c.get(serviceNames.queryFragments))
    )
    .register(serviceNames.zoomViewBaseController, (c) => new ZoomViewBaseController())
    .register(
        serviceNames.productZoomViewController,
        (c) => new ProductZoomViewController(c.get(serviceNames.zoomViewBaseController))
    )
    .register(
        serviceNames.productZoomButtonViewController,
        (c) => new ProductZoomButtonViewController(c.get(serviceNames.zoomViewBaseController))
    )
    .register(serviceNames.productGridSettings, (c) => new ProductGridSettings())
    .register(
        serviceNames.productFiltersViewController,
        diContainer.factory((c) => new ProductFiltersViewController())
    )
    .register(
        serviceNames.productBriefViewController,
        diContainer.factory((c) => new ProductBriefViewController())
    )
    .register(serviceNames.configRepository, (c) => new ConfigRepository())
    .register(serviceNames.config, (c) => new Config())
    .register(
        serviceNames.businessUnitIdParser,
        diContainer.factory((c) => {
            return new BusinessUnitIdParser(c.config.businessUnitId);
        })
    )
    .register(
        serviceNames.queryFragments,
        diContainer.factory((c) => {
            const businessUnitIdParser = c.get(serviceNames.businessUnitIdParser);
            const { config } = c.get(serviceNames.config);

            const queryFragmentsConfig = {
                features: config.features,
                brand: businessUnitIdParser.brand
            };

            return new QueryFragments(queryFragmentsConfig);
        })
    )
    .register(
        serviceNames.productCTAViewController,
        diContainer.factory(
            (c) =>
                new ProductCTAViewController(
                    c.get(serviceNames.productGridService),
                    c.get(serviceNames.productRepository),
                    c.get(serviceNames.dateFormatter)
                )
        )
    )
    .register(
        serviceNames.productCrossSellViewController,
        (c) => new ProductCrossSellViewController()
    )
    .register(
        serviceNames.productQuickViewController,
        diContainer.factory((c) => new ProductQuickViewController())
    )
    .register(
        serviceNames.productGridViewController,
        diContainer.factory(
            (c) =>
                new ProductGridViewController(
                    c.get(serviceNames.productGridSettings),
                    c.get(serviceNames.productGridService),
                    c.get(serviceNames.queryFragments)
                )
        )
    )
    .register(
        serviceNames.productGridService,
        diContainer.factory(
            (c) =>
                new ProductGridService(
                    c.get(serviceNames.productFilterService),
                    c.get(serviceNames.productSortingService),
                    c.get(serviceNames.productRepository)
                )
        )
    )
    .register(
        serviceNames.productSortingService,
        diContainer.factory(
            (c) =>
                new ProductSortingService(
                    c.get(serviceNames.productGridSettings),
                    c.get(serviceNames.productRepository)
                )
        )
    )
    .register(serviceNames.productShadesSidebarViewController, (c) => {
        return new ProductShadesSidebarViewController();
    })
    .register(serviceNames.productRepository, (c) => {
        return new ProductRepository({
            prodcatApiSdk: c.get(serviceNames.prodcatApiSdk)
        });
    })
    .register(
        serviceNames.productRatingViewController,
        diContainer.factory(
            (c) => new ProductRatingViewController(c.get(serviceNames.productRepository))
        )
    )
    .register(
        serviceNames.cartLimitReachedModalController,
        (c) => new CartLimitReachedModalController()
    )
    .register(serviceNames.prodcatApiSdk, (c) => {
        const configStore = c.get(serviceNames.configStore);
        const baseUrl = configStore.config.baseUrl;
        const businessUnit = configStore.config.businessUnitId;
        const clientId = configStore.config.clientId || 'stardust-fe-client';
        const config = {
            baseUrl,
            businessUnit,
            clientId
        };

        return new ProdcatApiSdk(config);
    })
    .register(serviceNames.productSkuRepository, (c) => {
        return new ProductSkuRepository({
            prodcatApiSdk: c.get(serviceNames.prodcatApiSdk),
            configStore: c.get(serviceNames.configStore)
        });
    })
    .register(
        serviceNames.serviceBusController,
        (c) =>
            new ServiceBusController(
                c.get(serviceNames.productRepository),
                c.get(serviceNames.productGridSettings)
            )
    )
    .register(
        serviceNames.dateFormatter,
        diContainer.factory((c) => {
            const { locale } = c.get(serviceNames.businessUnitIdParser);

            const dateFormatterConfig = { locale };

            return new DateFormatter(dateFormatterConfig);
        })
    )
    .register(
        serviceNames.priceFormatter,
        diContainer.factory((c) => {
            const businessUnitIdParser = c.get(serviceNames.businessUnitIdParser);
            const { config } = c.get(serviceNames.config);

            const priceFormatterConfig = {
                currency: config.currency,
                locale: businessUnitIdParser.locale
            };

            return new PriceFormatter(priceFormatterConfig);
        })
    )
    .register(
        serviceNames.productService,
        (c) =>
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            new ProductService((config: any) => {
                setConfig(config);

                return c.get(serviceNames.serviceBusController);
            })
    )
    .register(
        serviceNames.productFilterService,
        diContainer.factory((c) => new ProductFilterService())
    )
    .register(
        serviceNames.productInstallmentsPriceViewController,
        diContainer.factory(
            (c) => new ProductInstallmentsPriceViewController(c.get(serviceNames.priceFormatter))
        )
    )
    .register(
        serviceNames.productEngravingViewController,
        (c) => new ProductEngravingViewController()
    )
    .register(
        serviceNames.productShadePickerViewController,
        diContainer.factory((c) => new ProductShadePickerViewController())
    )
    .register(
        serviceNames.productShadePickerComponentViewController,
        diContainer.factory((c) => new ProductShadePickerComponentViewController())
    )
    .register(
        serviceNames.productBasicInfoViewController,
        (c) => new ProductBasicInfoViewController()
    )
    .register(
        serviceNames.productAutoReplenishmentViewController,
        diContainer.factory((c) => new ProductAutoReplenishmentViewController())
    )
    .register(
        serviceNames.productImagesSliderViewController,
        diContainer.factory((c) => new ProductImageSliderViewController())
    )
    .register(
        serviceNames.productSizePickerViewController,
        diContainer.factory((c) => new ProductSizePickerViewController())
    )
    .register(
        serviceNames.comparisonItemViewController,
        diContainer.factory((c) => new ComparisonItemViewController())
    )
    .register(
        serviceNames.productComparisonModuleViewController,
        diContainer.factory(
            (c) => new ProductComparisonModuleViewController(c.get(serviceNames.productRepository))
        )
    )
    .register(serviceNames.urlFormatter, (c) => {
        const { config } = c.get(serviceNames.config);
        const urlFormatterConfig = {
            langPrefix: config.domainLangPrefix
        };

        return new UrlFormatter(urlFormatterConfig);
    });

const { lazyInject } = getDecorators(diContainer);

export { lazyInject };
